<template>
    <header class="menu-box" :class="themeColor === 'white' ? 'white-theme' : ''">
        <nav class="navbar">
            <!-- logo -->
            <a href="https://partydaysport.com/en/index.html" class="default-logo"></a>
            <!-- 手机端图标 -->
            <div class="mobile-menu-icon" @click="changeMenuStatus">
                <img src="../assets/images/more.png" v-if="!isMenuShow && themeColor === 'black'">
                <img src="../assets/images/more-white.png" v-if="!isMenuShow && themeColor === 'white'">
                <i class="el-icon-close" v-if="isMenuShow"></i>
            </div>
            <!-- 菜单部分 -->
            <div class="navbar-collapse" :class="isMenuShow ? 'show' : 'hide'">
                <!-- 右菜单项 -->
                <ul class="navbar-nav">
                    <!-- PARTYDAY -->
                    <li class="nav-item">
                        <a class="nav-link" href="https://partydaysport.com/en/index.html">
                            <div class="font-effects">PARTYDAY</div>
                        </a>
                    </li>
                    <!-- ABOUT -->
                    <li class="nav-item">
                        <a class="nav-link" href="https://partydaysport.com/en/about.html">
                            <div class="font-effects">ABOUT</div>
                        </a>
                    </li>
                    <!-- PROJECTS -->
                    <li class="nav-item" @click="toggleMenu('PROJECTS')">
                        <a class="nav-link">
                            <div class="font-effects" :class="{ active: activeMenu === 'PROJECTS' }">PROJECTS</div>
                            <i class="el-icon-arrow-down"></i>
                        </a>
                        <ul class="dropdown-menu" v-show="activeMenu === 'PROJECTS'">
                            <li><a class="dropdown-item" href="https://partydaysport.com/en/project.html">
                                    <div class="font-effects">All PROJECTS</div>
                                </a></li>
                            <li><a class="dropdown-item"
                                    href="https://partydaysport.com/en/wuhan.html">
                                    <div class="font-effects">WUHAN</div>
                                </a></li>
                            <li><a class="dropdown-item"
                                    href="https://partydaysport.com/en/hangzhou.html">
                                    <div class="font-effects">HANGZHOU</div>
                                </a></li>
                            <li><a class="dropdown-item"
                                    href="https://partydaysport.com/en/shanghai-global-harbor.html">
                                    <div class="font-effects">SHANGHAI</div>
                                </a></li>
                            <li><a class="dropdown-item"
                                    href="https://partydaysport.com/en/shenzhen-longgang.html">
                                    <div class="font-effects">SHENZHEN LONGGANG</div>
                                </a></li>
                            <li><a class="dropdown-item"
                                    href="https://partydaysport.com/en/shenzhen-mega.html">
                                    <div class="font-effects">SHENZHEN MEGA</div>
                                </a></li>
                            <li><a class="dropdown-item"
                                    href="https://partydaysport.com/en/xian-livat.html">
                                    <div class="font-effects">XI'AN LIVAT</div>
                                </a></li>
                            <li><a class="dropdown-item"
                                    href="https://partydaysport.com/en/xian-zhonglou.html">
                                    <div class="font-effects">XI'AN BELL TOWER</div>
                                </a></li>
                            <li><a class="dropdown-item" href="https://partydaysport.com/en/multmedia.html">
                                    <div class="font-effects">MULTIMEDIA</div>
                                </a></li>
                        </ul>
                    </li>
                    <!-- PARTYSTATION -->
                    <li class="nav-item dropdown" @click="toggleMenu('PARTYSTATION')">
                        <a class="nav-link">
                            <div class="font-effects" :class="{ active: activeMenu === 'PARTYSTATION' }">PARTYSTATION
                            </div>
                            <i class="el-icon-arrow-down"></i>
                        </a>
                        <ul class="dropdown-menu" v-show="activeMenu === 'PARTYSTATION'">
                            <li><a class="dropdown-item" href="https://partydaysport.com/en/experiences.html">
                                    <div class="font-effects">PONDA PONDA</div>
                                </a></li>
                            <li><a class="dropdown-item" href="https://partydaysport.com/en/station.html">
                                    <div class="font-effects">PD TECHLAB</div>
                                </a></li>
                        </ul>
                    </li>
                    <!-- EXPERIENCES -->
                    <li class="nav-item dropdown" @click="toggleMenu('EXPERIENCES')">
                        <a class="nav-link">
                            <div class="font-effects" :class="{ active: activeMenu === 'EXPERIENCES' }">EXPERIENCES
                            </div>
                            <i class="el-icon-arrow-down"></i>
                        </a>
                        <ul class="dropdown-menu" style="width: 18vw;" v-show="activeMenu === 'EXPERIENCES'">
                            <li><a class="dropdown-item" href="https://partydaysport.com/en/news.html">
                                    <div class="font-effects">NEWS</div>
                                </a></li>
                            <li><a class="dropdown-item" href="https://partydaysport.com/en/merchandise.html">
                                    <div class="font-effects">BRAND ALLIANCE</div>
                                </a></li>
                            <li><a class="dropdown-item" href="https://partydaysport.com/en/teambuilding.html">
                                    <div class="font-effects">TEAM BUILDING PARTNERSHIP</div>
                                </a></li>
                            <li><a class="dropdown-item" href="https://partydaysport.com/en/study.html">
                                    <div class="font-effects">SPORTS&EDUCATION</div>
                                </a></li>
                        </ul>
                    </li>
                    <!-- CONTACT -->
                    <li class="nav-item">
                        <a class="nav-link" href="https://partydaysport.com/en/contact.html">
                            <div class="font-effects">CONTACT</div>
                        </a>
                    </li>
                    <!-- Ticket -->
                    <li class="nav-item">
                        <a class="nav-link">
                            <div class="font-effects active">TICKET</div>
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    </header>
</template>

<script>
export default {
    data() {
        return {
            isMenuShow: false,
            activeMenu: null
        };
    },
    props: {
        themeColor: {
            type: String,
            default: 'black' // 默认颜色
        }
    },
    mounted() {
        // 点击页面其他地方关闭下拉菜单
        document.addEventListener('click', this.closeAllMenus);
    },
    beforeDestroy() {
        // 移除事件监听
        document.removeEventListener('click', this.closeAllMenus);
    },
    methods: {
        toggleMenu(menuName) {
            // 如果点击的是当前已打开的菜单，则关闭它
            if (this.activeMenu === menuName) {
                this.activeMenu = null;
            } else {
                this.activeMenu = menuName;
            }
        },
        closeAllMenus(event) {
            // 如果点击的不是菜单项，则关闭所有菜单
            if (!event.target.closest('.nav-item')) {
                this.activeMenu = null;
            }
        },
        changeMenuStatus() {
            this.isMenuShow = !this.isMenuShow;
        }
    }
}
</script>

<style lang="less" scoped>
@font-face {
    font-family: 'AlibabaPuHuiTi-Regular';
    src: url('https://pdsite.partydaysport.com/official_website/AlibabaPuHuiTi-3-55-Regular.woff') format('woff');
}

.white-theme {

    .el-icon-arrow-down,
    .font-effects,
    .el-icon-close {
        color: #fff !important;
    }

    .default-logo {
        background-image: url('https://pdsite.partydaysport.com/official_website/pdlogo.png') !important;
    }
}

.menu-box {
    width: 100%;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    padding: 0 30px;
    box-sizing: border-box;
    font-family: 'AlibabaPuHuiTi-Regular';
    z-index: 10;
}

.navbar {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
}

/* 默认显示原始 logo */
.default-logo {
    display: block;
    width: 11vw;
    height: 6vw;
    background-image: url('https://pdsite.partydaysport.com/official_website/pdlogo-black.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% auto;
}

.default-logo:hover {
    background-image: url('https://pdsite.partydaysport.com/official_website/logo-blue.png')!important;;
}

.mobile-menu-icon {
    display: none;
}

.navbar-collapse {
    .navbar-nav {
        display: flex;

        .nav-item {
            padding: 0 1vw;
            transition: all .5s ease;
            position: relative;
            cursor: pointer;

            .nav-link {
                display: flex;
                align-items: center;

                .el-icon-arrow-down {
                    margin-top: .2vw;
                    font-size: .8vw;
                    font-weight: bold;
                    color: #000;
                }
            }

            .font-effects:hover,
            .font-effects.active {
                color: #6DEAF9!important;
            }

            .font-effects {
                color: #000;
                transition: all .5s ease;
                font-size: 0.8vw;
                font-weight: bold;
                position: relative;
                text-transform: capitalize;
                letter-spacing: 2px;
            }

            .font-effects::before {
                position: absolute;
                content: '';
                background: #6DEAF9;
                width: 100%;
                height: 1px;
                left: 0;
                bottom: -2px;
                transition: transform .5s ease-in;
                transform-origin: 0% 50%;
                transform: scaleX(0);
            }

            .font-effects:hover::before {
                transform: scaleX(1);
            }

        }
    }
}

.dropdown-menu {
    position: absolute;
    left: -30%;
    top: 100%;
    background: #fff;
    border: 1px solid #e4e6e5;
    width: 15vw;
    border-radius: 5px;
    margin-top: 15px;
    padding: 15px 15px 0;
    box-sizing: border-box;
    display: block;
    /* 改为block，通过v-show控制显示 */

    li {
        margin-bottom: 15px;
    }

    .font-effects {
        color: #000 !important;
    }
}

.dropdown-menu::before {
    content: '';
    width: 14px;
    height: 14px;
    background: #fff;
    border: 1px solid #e4e6e5;
    border-right: none;
    border-bottom: none;
    transform: translateX(-50%) rotateZ(45deg);
    position: absolute;
    top: -7px;
    left: 49%;
}

/* 响应式设计：在屏幕宽度小于 780px 时调整字体和布局 */
@media (max-width: 780px) {
    .mobile-menu-icon {
        display: block;
        width: 20px;
        height: 20px;
        margin-right: 10px;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        .el-icon-close {
            font-size: 23px;
            font-weight: bold;
        }
    }

    .navbar-collapse {
        display: block !important;
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        width: 100%;
        background: #fff;
        border: 1px solid #e4e6e5;
        border-radius: 4px;
        margin-top: 16px;
        overflow-y: auto;
        max-height: 0;
        opacity: 0;
        visibility: hidden;
        transform: translateY(-20px);
        transition: all 0.4s ease-in-out;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        padding: 0;

        .navbar-nav {
            width: 100%;
            flex-direction: column;
            gap: 20px;
            opacity: 0;
            transition: opacity 0.3s ease-in-out 0.1s;

            .dropdown-menu {
                width: 80% !important;
                position: static;
                margin: 20px auto 0;
                padding: 15px;

                .font-effects {
                    text-align: left;
                }

                li {
                    margin-bottom: 0;
                }
            }

            .dropdown-menu::before {
                top: 46px;
            }
        }

        .nav-item {
            width: 100%;
            padding: 0 !important;

            .el-icon-arrow-down {
                display: none;
            }
        }

        .font-effects {
            width: 100%;
            text-align: center;
            padding: 8px 0 10px;
            font-size: 3vw !important;
            color: #000 !important;
            display: block;
        }
    }

    .navbar-collapse.show {
        max-height: calc(100vh - 80px);
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
        padding: 20px 0;

        .navbar-nav {
            opacity: 1;
        }
    }

    .navbar-collapse.hide {
        max-height: 0;
        opacity: 0;
        visibility: hidden;
        transform: translateY(-20px);
        padding: 0;
    }

    .menu-box {
        padding: 0;

        .default-logo {
            width: 25vw;
            height: 20vw;
        }
    }
}
</style>